import { parseLocalDateString } from '../datetimeTransform';

const formatSlashDate = (dateString: string | null | undefined): string => {
  if (!dateString) return '-';

  const date = parseLocalDateString(dateString);
  if (Number.isNaN(date.getTime())) return '-';

  return date.toLocaleDateString('en-US');
};

export default formatSlashDate;
